/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feeplans": {
        "nested": {
          "pricing": {
            "nested": {
              "HeadlineFeeRateName": {
                "values": {
                  "DEFAULT_HEADLINE_FEE_RATE_NAME_DO_NOT_USE": 0,
                  "CARD_PRESENT": 1,
                  "INTERNAL_ACCOUNTS": 13,
                  "INTERNATIONAL_TRANSACTION": 28,
                  "CARD_NOT_PRESENT": 2,
                  "ONLINE": 3,
                  "ONLINE_API": 4,
                  "ACH_API": 5,
                  "ACH_INVOICES": 6,
                  "AFTERPAY": 7,
                  "GIFT_CARD_LOAD": 8,
                  "APP_SUBSCRIPTIONS": 9,
                  "ACH_APP_SUBSCRIPTIONS": 10,
                  "APP_SUBSCRIPTIONS_MARKETPLACE": 11,
                  "CASH_BUSINESS": 12,
                  "COST_PLUS_MARGIN": 14,
                  "INTERCHANGE_PLUS_MARGIN": 15,
                  "FREE": 16,
                  "MISSING_PRICING": 17,
                  "CASH_APP_LOCAL": 26,
                  "STORED_VALUE": 29,
                  "EBT": 30,
                  "CARD_NOT_PRESENT_KEYED": 18,
                  "CARD_NOT_PRESENT_ON_FILE": 19,
                  "CARD_PRESENT_PAID": 20,
                  "INVOICES": 21,
                  "ONLINE_API_EU": 22,
                  "ONLINE_API_NON_EU": 23,
                  "ONLINE_API_PAID_EU": 24,
                  "ONLINE_API_PAID_NON_EU": 25,
                  "CARD_PRESENT_POS": 27
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feeplans?.nested?.pricing?.nested?.HeadlineFeeRateName) {
  $root.addJSON(jsonData);
}

/**
 * A list of canonical headline fee rates that can apply to a payment.
 * Note: whenever adding new entries, please ensure you update all-protos and deploy
 * all of the following services, BEFORE setting up any pricing with the new rate in production:
 *  1. CPT (ebenezer)
 *  2. feeplans-graph  --> this supports Regulator
 *  3. Pricing Studio
 * This will ensure that UIs which use this proto do not break and display the DEFAULT_DO_NOT_USE value.
 *
 * SOURCE HeadlineFeeRateName @ squareup/feeplans/pricing/headline_fee_rates.proto at 15:1
 */
export const HeadlineFeeRateName = $root.lookupEnum('squareup.feeplans.pricing.HeadlineFeeRateName').values;